import { BuyTaxDetailsDataType } from '@buy/state/checkout/state'
import { BuyFormData } from '@buy/state/buy-form/state'

export const getTaxDetailValues = (values: BuyFormData) => {
    const taxDetails: BuyTaxDetailsDataType = {
        taxNumber: values.TaxNumber,
        federalTaxType: values.TaxType || null,
    }
    return taxDetails
}
